import {Image, Platform, Text, TouchableOpacity, View} from 'react-native';
import React, {useRef, useState} from 'react';
import {useTheme} from 'contexts/ThemeContext';
import MeatballMenuButton from 'components/atoms/meatballMenuButton';
import PopUp, {PopUpHandle} from 'components/atoms/popUp';
import strings from '../../../translations';
import styleSheet from './styles';

export interface DeleteScheduleProps {
  onPressCancelButton(): void;
  onPressDeleteButton(): void;
  title: string;
  classMarking: string;
  scheduledTime: string;
  classEndTime: string;
}

const DeleteSchedule = (props: DeleteScheduleProps) => {
  const theme = useTheme();
  const styles = styleSheet(theme);

  const ref = useRef<PopUpHandle>(null);

  const onHandlePopUp = () => {
    if (ref.current) {
      ref.current.switchVisible();
    }
  };

  const onPressCancelButton = () => {
    props.onPressCancelButton();
    onHandlePopUp();
  };

  const onPressDeleteButton = () => {
    props.onPressDeleteButton();
    onHandlePopUp();
  };

  const buttons = (
    <>
      <TouchableOpacity
        activeOpacity={0.8}
        onPress={onPressCancelButton}
        style={[styles.defaultButtonStyle, styles.cancelButtonStyle]}>
        <Image
          source={theme.images.crossTransparent}
          style={[styles.defaultImageStyle, styles.cancelImageStyle]}
        />
        <Text
          style={[
            styles.defaultLabelButtonStyle,
            styles.cancelLabelButtonStyle,
          ]}>
          {strings.homeScreen.cancelLesson}
        </Text>
      </TouchableOpacity>

      <TouchableOpacity
        activeOpacity={0.8}
        onPress={onPressDeleteButton}
        style={[styles.defaultButtonStyle, styles.deleteButtonStyle]}>
        <Image
          source={theme.images.deleteIcon}
          style={[styles.defaultImageStyle, styles.deleteImageStyle]}
        />
        <Text
          style={[
            styles.defaultLabelButtonStyle,
            styles.deleteLabelButtonStyle,
          ]}>
          {strings.homeScreen.deleteLesson}
        </Text>
      </TouchableOpacity>
    </>
  );

  const popUpContent = (
    <View style={styles.contentContainerStyle}>
      <View style={styles.metaDataClassContainerStyle}>
        <View>
          <Text style={styles.lessonTextStyle}>{props.title}</Text>
          <Text style={styles.textStyle}>{props.classMarking}</Text>
          <Text
            style={[
              styles.textStyle,
              styles.fontSize15,
            ]}>{`${props.scheduledTime}-${props.classEndTime}`}</Text>
        </View>

        <View>
          <TouchableOpacity
            activeOpacity={0.8}
            onPress={onHandlePopUp}
            style={styles.closePopUpButtonStyle}>
            <Image
              source={theme.images.crossTransparent}
              resizeMode="contain"
              style={styles.closePopUpImage}
            />
          </TouchableOpacity>
        </View>
      </View>

      <View style={styles.buttonContainerStyle}>{buttons}</View>
    </View>
  );

  return (
    <View>
      <MeatballMenuButton onPress={onHandlePopUp} />
      <PopUp ref={ref} backDropStyle={styles.backDropStyle}>
        {popUpContent}
      </PopUp>
    </View>
  );
};

export default DeleteSchedule;
